import React, { useState } from 'react';
import './PasswordInput.css';

const PasswordInput = ({ 
  value, 
  onChange, 
  placeholder = "Password", 
  disabled = false, 
  autoComplete = "current-password",
  required = false 
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="password-input-container">
      <input
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        required={required}
        className="password-input"
      />
      <button
        type="button"
        className="password-toggle-button"
        onClick={togglePasswordVisibility}
        disabled={disabled}
        aria-label={showPassword ? "Hide password" : "Show password"}
      >
        {showPassword ? (
          // Eye slash icon (hide password)
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.88 9.88L4.87 4.87C3.15 6.34 1.95 8.28 1.46 10.5C3.29 15.84 7.58 20 12 20C13.8 20 15.5 19.5 16.97 18.7L14.12 15.85C13.5 16.1 12.8 16.25 12 16.25C9.47 16.25 7.25 14.03 7.25 11.5C7.25 10.7 7.4 10 7.65 9.38L9.88 9.88ZM12 4.5C7.58 4.5 3.29 8.66 1.46 14C2.07 15.78 3.06 17.34 4.32 18.64L2.69 20.27L4.1 21.68L21.31 4.47L19.9 3.06L18.33 4.63C16.87 3.47 15.03 2.75 13 2.75H12C12 2.75 12 4.5 12 4.5ZM12 7C14.53 7 16.75 9.22 16.75 11.75C16.75 12.55 16.6 13.25 16.35 13.87L14.12 11.64C14.12 9.11 11.89 6.89 9.36 6.89L12 7Z" fill="currentColor"/>
          </svg>
        ) : (
          // Eye icon (show password)
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4.5C7.58 4.5 3.29 8.66 1.46 14C3.29 19.34 7.58 23.5 12 23.5C16.42 23.5 20.71 19.34 22.54 14C20.71 8.66 16.42 4.5 12 4.5ZM12 19C9.24 19 7 16.76 7 14C7 11.24 9.24 9 12 9C14.76 9 17 11.24 17 14C17 16.76 14.76 19 12 19ZM12 11C10.34 11 9 12.34 9 14C9 15.66 10.34 17 12 17C13.66 17 15 15.66 15 14C15 12.34 13.66 11 12 11Z" fill="currentColor"/>
          </svg>
        )}
      </button>
    </div>
  );
};

export default PasswordInput; 